'use client';
import { DownloadItem } from '@/components/content/HdmAditionalInfo/parts/DownloadItem';
import { FC } from 'react';

interface DownloadItemsProps {
	downloadableFiles: {
		order: string;
		type: string;
		url: string;
		id: string;
	}[];
}

export const DownloadItems: FC<DownloadItemsProps> = ({ downloadableFiles }) => {
	if (!downloadableFiles || downloadableFiles.length === 0) {
		return null;
	}

	return (
		<>
			{downloadableFiles.map((file) => (
				<DownloadItem key={file.order} name={file.type} url={file.url} id={file.id} />
			))}
		</>
	);
};
